import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import Media from 'react-media';
import { breakpoints } from '@chegg-ui/theme';
import { FooterContainer, FooterContent, Copyright, BackgroundLeft, BackgroundRight, FooterImages, LogoImages, FooterImageLink } from '../styles';
import DesktopFooterLinks from '../internals/DesktopFooterLinks';
import MobileFooterLinks from '../internals/MobileFooterLinks';

var Footer = function Footer(_ref) {
  var dataTest = _ref['data-test'],
      serverRenderAsMobile = _ref.serverRenderAsMobile,
      rest = _objectWithoutProperties(_ref, ["data-test", "serverRenderAsMobile"]);

  return (
    /*#__PURE__*/
    // top-level className passing is needed in order to allow SC inheritance via styled(Footer)``
    // please maintain this pass-through when building out your component
    React.createElement(FooterContainer, {
      "data-test": dataTest ? dataTest : undefined
    }, /*#__PURE__*/React.createElement(FooterContent, {
      role: "contentinfo"
    }, /*#__PURE__*/React.createElement(Media, {
      query: {
        maxWidth: breakpoints.md.max
      },
      defaultMatches: serverRenderAsMobile
    }, function (matches) {
      return matches ? /*#__PURE__*/React.createElement(MobileFooterLinks, rest) : /*#__PURE__*/React.createElement(DesktopFooterLinks, rest);
    }), /*#__PURE__*/React.createElement(FooterImages, null, /*#__PURE__*/React.createElement(LogoImages, null, /*#__PURE__*/React.createElement(FooterImageLink, {
      rel: "nofollow",
      href: "http://www.paypal.com",
      "data-test": "footer-paypal"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Paypal verified",
      src: "https://assets.chegg.com/image/upload/s--5SEFmVGX--/v1611341304/site-assets/cui/footer/paypal_logo.gif",
      loading: "lazy"
    })), /*#__PURE__*/React.createElement(FooterImageLink, {
      rel: "nofollow",
      href: "http://www.bbb.org/sanjose/business-reviews/books-textbooks-new-and-used/cheggcom-in-santa-clara-ca-238456",
      "data-test": "footer-bbb"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Better Business Bureau Seal",
      src: "//c.cheggcdn.com/images/bbbseal1.gif",
      loading: "lazy"
    })))), /*#__PURE__*/React.createElement(Copyright, null, "\xA9 2003-", new Date().getFullYear(), " Chegg Inc. All rights reserved.")), /*#__PURE__*/React.createElement(BackgroundLeft, {
      src: "https://assets.chegg.com/image/upload/s--xc1gY707--/c_scale,f_auto,h_130,q_auto/v1611781018/site-assets/cui/footer/footer-left.svg",
      alt: "",
      role: "presentation",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement(BackgroundRight, {
      src: "https://assets.chegg.com/image/upload/s--oKb89MX2--/c_scale,f_auto,q_auto,w_387/v1611783492/site-assets/cui/footer/footer-right.svg",
      alt: "",
      role: "presentation",
      loading: "lazy"
    }))
  );
};

Footer.displayName = 'Footer';
export default Footer;